import fetchAPI from 'utils/functions/fetchAPI';
import { clientMeUrl } from '../const';

export const validateClientTheme = async () => {
  return fetchAPI.request({
    url: `${clientMeUrl}/builtin/themes/validation`,
    method: 'GET',
  });
};
